<template lang="pug">
  .documents-list-business.table-view
    .table-view-header
      .table-view-header-title
        h3 Documentos
        b-input-group.table-view-header-filter
            template(v-slot:prepend)
              .filter-prepend
                font-awesome-icon(:icon="['fas', 'search']")
            b-form-input(v-model="search" placeholder="buscar")
    b-table(
      :fields="fields"
      thead-class="bg-light-primary"
      :items="businesses"
      @row-clicked="goToBusinessFolders"
      :filter="search"
      :filter-included-fields="['name', 'rut', 'legalRepresentative']"
      hover
      responsive)
      template(v-slot:cell(name)="{value}")
        font-awesome-icon(:icon="['fas', 'folder']")
        span.ml-2 {{value}}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      search: '',
      fields: [
        { label: 'Nombre', key: 'name', sortable: true},
        { label: 'rut', key: 'rut', sortable: true},
        { label: 'Propietario', key: 'legalRepresentative', sortable: true},
      ]
    }
  },
  methods: {
    ...mapActions(['listActiveBusiness']),
    goToBusinessFolders (business) {
      const businessId = business.id
      this.$router.push({ name: 'BusinessFolders', params: { businessId } })
    }
  },
  computed: {
    ...mapGetters(['businesses'])
  },
  created () {
    this.listActiveBusiness()
  }
}
</script>